import React, { useState } from 'react'
import { ModalBody } from 'reactstrap'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { Input } from '@/components/inputs'
import { openTwoFactorDialog } from '@/utils/twoFactorHelper'
import ErrorBoundary from '@/components/ErrorBoundary'

const EditPhoneNumberDialog = (props) => {
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || '')
  return (
    <ValidationBoundary>
      <BasicHeader title='Security.PhoneNumber' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Validator name='phoneNumber' value={phoneNumber} maxLength={32} regex='^(\+\d)?\d*$'>
            <Input className='phone-input' id='name' onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber} />
          </Validator>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={() => openTwoFactorDialog(() => props.onAction({ phoneNumber }))} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: EditPhoneNumberDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editPhoneNumber.js